import { Municipality } from 'shell/models/municipality';

/**
 * Returns a string representation of the consulate value for the given municipality.
 *
 * This string is composed by the consulate code, the consulate name, the consulate location
 * and the location name. The fields are separated by ' - '.
 *
 * @param {Municipality} municipality The municipality to be translated.
 * @return {string} The translated consulate value.
 */
export const translateConsulateValue = (municipality: Municipality): string => {
  const { comuneTerritorioConsolato = {} } = municipality || {};
  const { territorioConsolato = {} } = comuneTerritorioConsolato || {};
  const { key, consolato = { nome: '', comune: { nome: '' } } } = territorioConsolato || {};

  let translatedValue = '';

  if (key?.codiceConsolato) {
    translatedValue += `${key?.codiceConsolato || ''}${
      consolato?.nome || consolato?.comune?.nome ? ' - ' : ''
    }`;
  }

  if (consolato?.nome) {
    translatedValue += `${consolato?.nome || ''}${consolato?.comune?.nome ? ' - ' : ''}`;
  }

  if (consolato?.comune?.nome) {
    translatedValue += consolato?.comune?.nome;
  }

  return translatedValue;
};
